import notification from "antd/es/notification";
import { defineMessage, IntlShape } from "react-intl";

const message = defineMessage({
  id: "reports.cumul.dashboard.export.message",
  defaultMessage: "Export processing",
  description: "Dashboard export download message",
});
const description = defineMessage({
  id: "reports.cumul.dashboard.export.downloadInfo",
  defaultMessage: "This dashboard will be downloaded directly to your browser in just a moment.",
  description: "Dashboard export download description",
});

const showDashboardDownloadInfo = (intl: IntlShape) =>
  notification.info({
    description: intl.formatMessage(description),
    message: intl.formatMessage(message),
  });

export default showDashboardDownloadInfo;
